import type { ClubData } from "libs/apiClient";
import type { ProgramGameSelectOption } from "./types";

/**
 * Maps the `addUpdateNPClub` response club to a Program Game select option.
 * Returns null when the response lacks a usable id or name.
 */
export function buildCreatedClubOption(
	club: ClubData | null | undefined,
): ProgramGameSelectOption | null {
	if (!club || club.id === null || club.id === undefined || !club.name) {
		return null;
	}
	return { value: club.id, label: club.name };
}
